import React from "react";
import { styled } from "styled-components";
const StyledContainer = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: rows wrap;
  width: 100%;
  max-height: 650px;
  overflow: hidden;
`;
export default function Container(props) {
  return (
    <StyledContainer className="tt-container">{props.children}</StyledContainer>
  );
}
